import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryCollaborationsDetails = () => {
    const {id} = useParams()
    const [collaboration_details,setCollaborationDetails] = useState(null)
    // console.log("The collaboration details is:",collaboration_details)
    const fetchCollaborationDetails =async () =>{
         try {
            const response = await axios.get(
            `${BASE_URL}/marketplace/industry/collaboration/${id}/`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            }
        )
         setCollaborationDetails(response.data)
         } catch (error) {
            console.log("error while fetch collaboration details",error)
         }
    }
    useEffect(()=>{
        if(!id) return;
        fetchCollaborationDetails()
    },[id])
 const HandleChangeStatus = async (status) => {
  try {
    await axios.patch(
      `${BASE_URL}/marketplace/industry/collaboration/${id}/`,
      { status: status },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );

    alert("Collaboration Status Updated Successfully!");
    fetchCollaborationDetails()
  } catch (error) {
    console.log("error while updating status", error);
  }
};
  return (
<div className="flex items-start justify-center">
  <div className="w-full">
    {/* Version 1.3: Accept, Reject, Delete buttons + icons on Description, Problem, and 4 fields */}
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8 space-y-6">
      {/* Profile Section: img, name, email, status + Accept/Reject/Delete Buttons */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 border border-gray-200 shadow-sm">
            <img
              src={collaboration_details?.profile_data?.profile_picture}
              className="w-full h-full object-cover"
              alt={collaboration_details?.profile_data?.name}
            />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">{collaboration_details?.profile_data?.name}</h3>
            <p className="text-sm text-gray-500">{collaboration_details?.profile_data?.email}</p>
            {/* <p className="text-sm text-gray-500">Professor | AI Researcher</p> */}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium border border-green-100 capitalize">{collaboration_details?.status === 'pending' ? "Pending" : collaboration_details?.status ==='accept' ? "Accepted" : "Rejected"}</span>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100"></div>

      {/* Project Title & Domain */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-gray-50 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Project Title</p>
            <p className="text-base font-semibold text-gray-900">{collaboration_details?.project_title}</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Project Domain</p>
            <p className="text-base font-semibold text-gray-900">{collaboration_details?.project_domain}</p>
          </div>
        </div>
      </div>

      {/* Project Description */}
      <div className="bg-gray-50 rounded-xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" />
          </svg>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">Project Description</p>
          <p className="text-sm text-gray-700 leading-relaxed">{collaboration_details?.project_description}</p>
        </div>
      </div>

      {/* Problem Statement */}
      <div className="bg-gray-50 rounded-xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">Problem Statement</p>
          <p className="text-sm text-gray-700 leading-relaxed">{collaboration_details?.problem_statement}</p>
        </div>
      </div>

      {/* Collaboration & Support */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-gray-50 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Collaboration Type</p>
            <p className="text-base font-semibold text-gray-900">{collaboration_details?.collaboration_type}</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-4 flex items-start gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">Expected Support from Industry</p>
            <p className="text-sm text-gray-700">{collaboration_details?.expected_support}</p>
          </div>
        </div>
      </div>

      {/* Project Details Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-3">
          <div className="w-9 h-9 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Current Stage</p>
            <p className="text-sm font-semibold text-gray-900">{collaboration_details?.current_project_stage}</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-3">
          <div className="w-9 h-9 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Duration</p>
            <p className="text-sm font-semibold text-gray-900">{collaboration_details?.project_duration}</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-3">
          <div className="w-9 h-9 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Budget</p>
            <p className="text-sm font-semibold text-gray-900">${collaboration_details?.budget_requirement}</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-3">
          <div className="w-9 h-9 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Demo Link</p>
            <a href={collaboration_details?.demo_link} className="text-sm font-semibold text-[#0f6abf] hover:underline">GitHub</a>
          </div>
        </div>
      </div>
      
      {/* PDF File Preview */}
      <div className="bg-gray-50 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Attached Proposal File</p>
        </div>
        <iframe
          src={collaboration_details?.proposal_document}
          className="w-full h-96 rounded-xl border border-gray-200"
          title="PDF Preview"
        ></iframe>
      </div>
      
      {/* Technology Stack */}
     <div className="bg-gray-50 rounded-xl p-4">
  <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">
    Technology Stack
  </p>

  <div className="flex flex-wrap gap-2">

    {collaboration_details?.technology_stack
      ?.split(",")
      ?.map((tech, index) => (
        <span
          key={index}
          className="px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg text-xs font-medium"
        >
          {tech}
        </span>
      ))}

  </div>
</div>

      {/* Additional Notes */}
      <div className="bg-gray-50 rounded-xl p-4">
        <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">Additional Notes</p>
        <p className="text-sm text-gray-700">{collaboration_details?.additional_notes}</p>
      </div>

    </div>

  </div>

</div>
  )
}

export default IndustryCollaborationsDetails
